import { Box } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { useState, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import MainNavbar from "./main/MainNavbar";
import MainFooter from "./main/MainFooter";
// import MainSidebar from "./main/MainSidebar";
import { MAIN_ROUTES } from "./MAIN_ROUTES";

const MainLayout = ({ children }) => {
  const { pathname } = useLocation();
  const settings = MAIN_ROUTES.filter((item) => item.url === pathname)[0];
  const [opened, { toggle, close }] = useDisclosure(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    opened && close();
  }, [pathname]);

  const isTransparent = !!settings?.transparent;
  const isFooter = !!settings?.footer;

  return (
    <Box pt={isTransparent ? 0 : 80}>
      <MainNavbar opened={opened} toggle={toggle} isTransparent={isTransparent} />
      {/* <MainSidebar onClose={() => setIsSidebarMobileOpen(false)} open={isSidebarMobileOpen} /> */}
      {children || <Outlet />}
      {isFooter && <MainFooter />}
    </Box>
  );
};

export default MainLayout;
